import { getApiClient } from "../http/client";
import type { DataResponse } from "../http/types";
import type { AllSitesDashboard, SiteDashboard } from "./types";

const ALL_SITES_PATH = "/control/dashboard";
const SITE_PATH = (siteId: number) => `/control/dashboard/sites/${siteId}`;

async function getAllSites(): Promise<AllSitesDashboard> {
  const res = await getApiClient().get<DataResponse<AllSitesDashboard>>(ALL_SITES_PATH);
  return res.data;
}

async function getSite(siteId: number): Promise<SiteDashboard> {
  const res = await getApiClient().get<DataResponse<SiteDashboard>>(SITE_PATH(siteId));
  return res.data;
}

export const controlService = {
  getAllSites,
  getSite,
};
